import { JsonObject, JsonProperty } from "json2typescript";
import { Participant } from "src/models/Participant";

@JsonObject("ProjectDetail")
export class ProjectDetail {
   
   @JsonProperty("id", String) 
   public id: string = "" 

   @JsonProperty("name", String)
   public name: string = ""

   @JsonProperty("description", String)
   public description: string = ""

   @JsonProperty("participants",[])
   public participants: Participant[] = []

}


// WEBPACK FOOTER //
// ./src/models/ProjectDetail.ts